import './horizontal-auto-slider.scss'
import { Swiper, Pagination, Autoplay } from 'swiper'

const init = () => {
  Swiper.use([Autoplay, Pagination])

  new Swiper('.horizontal-auto-slider__slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    simulateTouch: false,

    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    pagination: {
      el: '.horizontal-auto-slider__navigation',
      clickable: true,

      renderBullet: function (index, className) {
        const name = this.el.dataset.pagination.split(',') || []

        return `<div class="slider-tab ${className}">
          ${
            name[index] &&
            `
            <p class="text text_default-400">
              ${index >= 10 ? index + 1 : `0${index + 1}`}.
            </p>
            <div class="slider-tab__info">
              <h5 class="heading heading_as-h5 heading_responsible-yes slider-tab__tite">
                ${name[index]}
              </h5>
            </div>
          `
          }
        </div>`
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  init()
})
